export const AppCultureSante = "https://app.lisaconnect.fr/";

// export const AppPrevention = "https://www.lisaconnect.fr/";
